import { combineReducers } from 'redux'

// reducer import
import customizationReducer from './reducers/customizationReducer'
import canvasReducer from './reducers/canvasReducer'
import notifierReducer from './reducers/notifierReducer'
import dialogReducer from './reducers/dialogReducer'
import agentsReducer from './reducers/agentReducers/agentsReducer';
import addAgentReducer from './reducers/agentReducers/addAgentReducers' // Import the new reducer
import addToolsReducer from './reducers/toolsReducers/addToolsReducers'
import toolsReducer from './reducers/toolsReducers/listToolsReducers'
import { authReducer } from './reducers/loginReducers'
import keyKnowReducer from './reducers/knowledgeReducers/listingKeys'
import addKnowReducers from './reducers/knowledgeReducers/addKnowReducers'
import editKnowReducers from './reducers/knowledgeReducers/editKnowledge'
import addNodesReducer from './reducers/nodeReducers/addNodesReducers'
import { editNodesReducer } from './reducers/nodeReducers/addNodesReducers'

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
    customization: customizationReducer,
    canvas: canvasReducer,
    notifier: notifierReducer,
    dialog: dialogReducer,
    agents: agentsReducer,
    addAgent: addAgentReducer,
    addTools: addToolsReducer,
    tools: toolsReducer,
    auth:authReducer,
    keyKnowReducer: keyKnowReducer,
    addKnowReducers: addKnowReducers,
    editKnowReducers: editKnowReducers,
    addNodesReducer: addNodesReducer,
    editNodesReducer: editNodesReducer
})


export default reducer;

// Export RootState type for use in selectors
export type RootState = ReturnType<typeof reducer>;